import { render, staticRenderFns } from "./EnviromentsNew.vue?vue&type=template&id=21fb007f&scoped=true&"
import script from "./EnviromentsNew.vue?vue&type=script&lang=js&"
export * from "./EnviromentsNew.vue?vue&type=script&lang=js&"
import style0 from "./EnviromentsNew.vue?vue&type=style&index=0&id=21fb007f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb007f",
  null
  
)

export default component.exports